import Config from 'config/settings';
import { device } from 'utils/device';

export default class ProjectHeaderSizes {
	public static heightFromMobileDesign(orginalDesignedHeight: number, round = true, skipFix = false): number {
		let designedWidth = 375;
		let ratio = device.innerWidth / designedWidth;
		let height = round ? Math.round(ratio * orginalDesignedHeight) : ratio * orginalDesignedHeight;

		if (!skipFix && height / device.innerHeight < 0.36) {
			height = device.innerHeight * 0.36;
		}

		return height;
	}

	public static headerWidth(): number {
		let innerWidth: number = device.innerWidth;


		return innerWidth;
	}

	public static headerHeight(): number {
		let innerHeight: number = device.innerHeight;
		let innerWidth: number = device.innerWidth;
		let imageHeight: number = 375;

		if (device.isPortraitDevice && innerWidth <= 750) {
			if (innerWidth >= Config.squareProjectHeaderWidth) {
				return device.innerWidth * 0.75;
			}

			return device.innerWidth;

			//Ratio gets smaller on bigger height devices:
			let designedRatio = 0.667;
			let maxRatioDesigned = 0.5897;
			let designedInnerHeight = 553;
			let designedInnerMaxHeight = 666;
			let diff = designedRatio - maxRatioDesigned;
			let range = designedInnerMaxHeight - designedInnerHeight;
			let r = range == 0 ? 0 : (device.innerHeight - designedInnerHeight) / range;

			if (r > 1) r = 1;
			else if (r < 0) r = 0;

			let heightRatio = designedRatio - diff * r;
			return Math.round(device.innerHeight * heightRatio);
		}

		let height = Math.round((device.innerWidth / 1920) * 738);

		if (height / device.innerHeight > 0.7) {
			return Math.round((device.innerWidth / 1920) * 650);
		}

		return height;

		if (innerHeight > 500 && innerHeight < 1000) {
			imageHeight = ProjectHeaderSizes.videoSize().height * (innerHeight / 1000);
		} else if (innerHeight > 1000) {
			imageHeight = ProjectHeaderSizes.videoSize().height * (innerWidth / 1920);
		}



		return imageHeight;
	}

	public static headerSize(): any {
		return {
			width: ProjectHeaderSizes.headerWidth(),
			height: ProjectHeaderSizes.headerHeight()
		};
	}

	public static videoSize(): any {
		return { width: 1920, height: 738 };
	}

	public static headerYPosition(): number {
		return device.innerWidth < 700 ? 0 : 0;
	}
}
